import { faArrowUp, faBug } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Dispatch, SetStateAction } from "react";
import Swal from "sweetalert2";
import { Spinner } from "../../../../../Components/Loding/SpinnerPadrao";
import {
    IGetBugCardDevOpsByIDCaso,
    IResultadoBuscaCardPorIdDevops,
} from "../../../../../Interfaces/DevOps/DevOps";

interface IInfoCardPesquisado {
    valorCardPesquisado: string;
    searchUnlinkedBugCardsValue: IResultadoBuscaCardPorIdDevops;
    LinkUnLinkBugCards: (
        NrDevOpsCard: number,
        idCaso: number,
        flLinkCard: boolean
    ) => Promise<any>;
    ID_CASO: number;
    updateAtendimento: () => void;
    GetBugCardDevOpsByIDCaso: (
        ...args: any[]
    ) => Promise<IGetBugCardDevOpsByIDCaso | undefined>;
    setShow: Dispatch<SetStateAction<boolean>>;
    LinkUnLinkBugCardsLoading: boolean;
}

export default function InfoCardPesquisado(props: IInfoCardPesquisado) {
    return (
        <div className="mt-2 d-flex flex-column justify-content-center w-50">
            <div className="m-4 justify-content-center">
                <div className="d-flex align-items-center">
                    <FontAwesomeIcon
                        icon={faBug}
                        className="text-danger mr-2 mb-0"
                    />
                    <p className="mb-0 mr-3">{props.valorCardPesquisado}</p>
                    <p className="font-weight-bold mt-1 mb-1">
                        {
                            props.searchUnlinkedBugCardsValue.devOpsCardInfo
                                .dS_TITULO
                        }
                    </p>
                </div>
                <div className="d-flex align-items-center my-2">
                    <div
                        style={{
                            height: "8px",
                            width: "8px",
                            backgroundColor: "gray",
                            borderRadius: "50%",
                            marginRight: "5px",
                        }}
                    />
                    <p className="card-text">
                        {
                            props.searchUnlinkedBugCardsValue.devOpsCardInfo
                                .dS_STATE
                        }
                    </p>
                </div>
                <div className="d-flex align-items-center mb-2">
                    <img
                        className="rounded-circle mr-1"
                        style={{
                            height: "25px",
                            width: "25px",
                        }}
                        src={
                            props.searchUnlinkedBugCardsValue.devOpsCardInfo
                                .dS_RESPONSAVEL.picture ??
                            "https://w7.pngwing.com/pngs/178/595/png-transparent-user-profile-computer-icons-login-user-avatars-thumbnail.png"
                        }
                        alt="imagem responsável"
                    />{" "}
                    {props.searchUnlinkedBugCardsValue.devOpsCardInfo
                        .dS_RESPONSAVEL.displayName ??
                        "Sem usuário responsável"}
                </div>
                <div className="d-flex justify-content-between">
                    <div>
                        {props.searchUnlinkedBugCardsValue.devOpsCardInfo.dS_TIPO_ATIVIDADE
                            ?.split(";")
                            ?.map((activity: any, index: number) => (
                                <span
                                    key={index}
                                    className="badge bg-secondary my-1 mr-1"
                                >
                                    {activity.trim()}{" "}
                                </span>
                            ))}
                    </div>
                </div>
            </div>
            <button
                type="button"
                className={`btn btn-success`}
                onClick={() => {
                    Swal.fire({
                        title: "Deseja vincular o card a esse atendimento?",
                        icon: "info",
                        buttonsStyling: false,
                        confirmButtonText: "<i class='la la-check'></i> Sim!",
                        showCancelButton: true,
                        cancelButtonText:
                            "<i class='la la-thumbs-down'></i> Não",
                        customClass: {
                            confirmButton: "btn btn-outline-success",
                            cancelButton: "btn btn-default",
                        },
                    }).then((result) => {
                        if (result.isConfirmed) {
                            props
                                .LinkUnLinkBugCards(
                                    Number(props.valorCardPesquisado),
                                    props.ID_CASO,
                                    true
                                )
                                .then(() => {
                                    props.setShow(false);
                                    props.updateAtendimento();
                                    props.GetBugCardDevOpsByIDCaso();
                                    localStorage.setItem("vincularCards", "2");
                                });
                        }
                    });
                }}
            >
                {props.LinkUnLinkBugCardsLoading ? (
                    <Spinner size="sm" />
                ) : (
                    <FontAwesomeIcon icon={faArrowUp} />
                )}{" "}
                Vincular
            </button>
        </div>
    );
}
